import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=1b6f58b8&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=1b6f58b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f58b8",
  null
  
)

export default component.exports